import React from 'react';
import './OutcomeCardAtom.scss';

export type OutcomeCardHue = 'green' | 'blue' | 'amber' | 'violet';

export interface OutcomeCardAtomProps {
  icon: string;
  title: string;
  body: string;
  hue: OutcomeCardHue;
  className?: string;
}

const OutcomeCardAtom: React.FC<OutcomeCardAtomProps> = ({
  icon,
  title,
  body,
  hue,
  className = '',
}) => {
  const classes = [
    'marketplace-outcome-card',
    `marketplace-outcome-card--${hue}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <article className={classes}>
      <span className="marketplace-outcome-card__icon-wrap" aria-hidden="true">
        <i className={`pi ${icon} marketplace-outcome-card__icon`} />
      </span>
      <div className="marketplace-outcome-card__text">
        <h3 className="marketplace-outcome-card__title">{title}</h3>
        <p className="marketplace-outcome-card__body">{body}</p>
      </div>
    </article>
  );
};

OutcomeCardAtom.displayName = 'OutcomeCardAtom';

export default OutcomeCardAtom;
